const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

export async function fetchWithAuth(path, options = {}) {
  const token = localStorage.getItem('token');

  const headers = {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
    ...options.headers
  };

  // Remove Content-Type for FormData
  if (options.body instanceof FormData) {
    delete headers['Content-Type'];
  }

  try {
    const response = await fetch(`${API_URL}${path}`, {
      ...options,
      headers
    });

    // Auto-logout on 401
    if (response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/';
      return null;
    }

    if (!response.ok) {
      // Some failures (a proxy error, a crash before the JSON body) are not JSON
      // at all; fall back rather than throwing a SyntaxError over the real cause.
      let payload = {};
      try {
        payload = await response.json();
      } catch (_) {
        payload = {};
      }
      const err = new Error(payload.message || `Request failed (${response.status})`);
      // The stable machine code the UI translates on, and the status for callers
      // that need to distinguish 403 from 409 without string-matching.
      err.code = payload.code;
      err.status = response.status;
      err.payload = payload;
      throw err;
    }

    return response.json();
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
}

export { API_URL };
